import React from 'react'
import { useParams } from 'react-router-dom'
import ManageLightspeed from './ManageLightspeed'
import { PARTNER_SLUGS } from '../constants'

export const ManageIntegrations = () => {
  const { slug } = useParams()

  if (slug === PARTNER_SLUGS.LIGHTSPEED) {
    return <ManageLightspeed />
  }

  return <></>
}

export default ManageIntegrations
